/*jshint esversion: 6 */
/*jshint strict: false */

// import Alpine from "alpinejs";
//
// document.addEventListener('alpine:init', () => {
// 	Alpine.data("autocomplete", () => ({
// 		completions: [1, 2, 3],
// 		search: {
// 			['@keydown.debounce']() {
// 				let value = this.$event.target.value;
//
// 				fetch(this.$root.dataset.autocompleteSource+'&term='+value)
// 					.then(response => response.json())
// 					.then(json => this.completions = json.completions);
// 			},
// 		}
// 	}));
// });
//
// Alpine.start();

import Awesomeplete from 'awesomplete'
import 'awesomplete/awesomplete.css'

const searchForm = document.querySelectorAll('form[data-autocomplete-source]')

searchForm.forEach((form) => {
	const queryInput = form.querySelector('input[name=search]')

	if (queryInput) {
		const awesomplete = new Awesomeplete(queryInput, {
			filter: () => true,
			sort: false,
			list: [],
			tabSelect: true,
			autoFirst: false,
			replace: function (text) {
				var before = this.input.value.match(/^.+\s+|/)[0];
				this.input.value = before + text;
			}
		})

		queryInput.addEventListener('input', (event) => {
			const words = event.target.value.split(" ")
			const value = words[words.length - 1]

			fetch(form.dataset.autocompleteSource + '&term=' + value)
				.then(response => response.json())
				.then(json => {
					awesomplete.list = json.suggestions.map(x => x.title)
					awesomplete.evaluate()
				})
		})
	}
})

